import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const ClientsPage = lazy(() => import('./pages/clients'))
const ClientsAddPage = lazy(() => import('./pages/clientsAdd'))
const ClientsLoyaltyPage = lazy(() => import('./pages/clientsLoyalty'))
const ClientsLoyaltyTierPage = lazy(() => import('./pages/clientsTier'))
export const clientsRoutes = () => {
  return (
    <>
      <Route path={pageUrl.client} element={<ClientsPage />} />
      <Route path={pageUrl.clientAdd} element={<ClientsAddPage />} />
      <Route
        path={pageUrl.clientLoyaltyPoints}
        element={<ClientsLoyaltyPage />}
      />
      <Route
        path={pageUrl.clientLoyaltyTiers}
        element={<ClientsLoyaltyTierPage />}
      />
    </>
  )
}
